import React from 'react';
import SolutionsPageComponent from '../components/SolutionsPage/SolutionsPage';

/**
 * SolutionsPage - Solutions landing page wrapper
 */
export default function SolutionsPage() {
  return <SolutionsPageComponent />;
}
